// Only append operations can be merged without reapplying removals or ordering.
export function additionOnlySongIds(originalIds, draftSongs) {
  if (!Array.isArray(originalIds) || !Array.isArray(draftSongs)) return null;
  const draftIds = draftSongs.map((song) => song.id);
  if (new Set(originalIds).size !== originalIds.length || new Set(draftIds).size !== draftIds.length) return null;
  const originals = new Set(originalIds);
  const retained = draftIds.filter((id) => originals.has(id));
  if (retained.length !== originalIds.length || retained.some((id, index) => id !== originalIds[index])) return null;
  return draftIds.filter((id) => !originals.has(id));
}

export function prepareFreshPlaylistEditor(requested, latest) {
  const originalIds = requested.originalSongIds;
  const draft = requested.songs;
  const additions = additionOnlySongIds(originalIds, draft);
  const hasDraft = Array.isArray(originalIds) && Array.isArray(draft);
  // Preserve pending removals/reordering and their original snapshot for conflict review.
  const latestIds = new Set(latest.songs.map((song) => song.id));
  const draftById = new Map((draft || []).map((song) => [song.id, song]));
  const songs = hasDraft && additions === null ? draft : [
    ...latest.songs,
    ...(additions || []).filter((id) => !latestIds.has(id)).map((id) => draftById.get(id)),
  ];
  return {
    ...latest,
    songs,
    originalSongIds: hasDraft && additions === null ? originalIds : latest.songs.map((song) => song.id),
    name: requested.originalName !== undefined && requested.name !== requested.originalName ? requested.name : latest.name,
    type: requested.originalType !== undefined && requested.type !== requested.originalType ? requested.type : latest.type,
    originalName: latest.name,
    originalType: latest.type,
  };
}
